import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../i18n';

const NavBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div
            className="w-full h-[100px] bg-slate-50 shadow-md flex items-center justify-between px-6 md:px-20"
            style={{ zIndex: 50 }}
        >
            <div id="logo">
                <a href="/">
                    <img className="" src="/logos/logo-save.png" alt="saveenergy" />
                </a>
            </div>

            <div
                className="md:hidden cursor-pointer"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
                <div className="w-6 h-0.5 bg-[#3d1053] mb-1"></div>
                <div className="w-6 h-0.5 bg-[#3d1053] mb-1"></div>
                <div className="w-6 h-0.5 bg-[#3d1053]"></div>
            </div>

            <div
                id="nav"
                className={`absolute top-[100px] left-0 w-full bg-slate-50 shadow-md flex flex-col items-center space-y-6 py-6 md:py-0 md:space-y-0 md:flex-row md:static md:w-auto md:space-x-8 md:shadow-none transition-all ${isMenuOpen ? 'block' : 'hidden'} md:flex`}
                style={{ zIndex: 40 }}
            >
                <a href="/produtos" className="font-semibold text-[#3d1053]">
                    {t('nav.products')}
                </a>
                <a
                    href="/catalogo"
                    className="font-semibold text-[#3d1053]"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('nav.catalog')}
                </a>
                <a href="/institucional" className="font-semibold text-[#3d1053]">
                    {t('nav.institutional')}
                </a>
                
                {/* Link do Showroom adicionado aqui */}
                <a href="/showroom" className="font-semibold text-[#3d1053]">
                    {t('nav.showroom', 'SHOWROOM')}
                </a>

                {/* Início do Menu Expansível Ajustado */}
                <div className="relative group flex flex-col items-center md:block">
                    <span className="font-semibold text-[#3d1053] flex items-center gap-1 cursor-pointer md:py-2">
                        {t('nav.professionalSpace', 'ESPAÇO DO PROFISSIONAL')}
                        <svg className="w-4 h-4 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </span>
                    
                    {/* Ponte invisível com pt-2 para não perder o hover */}
                    <div className="md:absolute md:left-0 md:top-full w-full md:w-56 hidden group-hover:flex flex-col z-50 md:pt-2">
                        {/* O fundo e a borda vão no container interno */}
                        <div className="bg-slate-50 md:bg-white md:border md:border-gray-100 md:rounded-md md:shadow-lg flex flex-col overflow-hidden">
                            <a
                                href="/canal-do-arquiteto"
                                className="block px-4 py-3 text-sm text-[#3d1053] hover:bg-gray-200 font-semibold text-center md:text-left transition-colors"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t('nav.architectChannel', 'CANAL DO ARQUITETO')}
                            </a>
                            <a
                                href="/canal-do-instalador"
                                className="block px-4 py-3 text-sm text-[#3d1053] hover:bg-gray-200 font-semibold text-center md:text-left transition-colors"
                            >
                                {t('nav.installerChannel', 'CANAL DO INSTALADOR')}
                            </a>
                        </div>
                    </div>
                </div>
                {/* Fim do Menu Expansível */}

                <a
                    href="https://save.com.br/blog/"
                    className="font-semibold text-[#3d1053]"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('nav.blog')}
                </a>
                <a href="/suporte" className="font-semibold text-[#3d1053]">
                    {t('nav.support')}
                </a>
            </div>

            <div className="hidden md:flex items-center space-x-4">
                <a
                    href="https://www.facebook.com/saveenergyiluminacao/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="/media/icones_social/facebook.svg"
                        alt="Facebook"
                        className="w-6 h-6 hover:scale-110 transition-transform duration-200"
                    />
                </a>
                <a
                    href="https://www.instagram.com/saveenergyiluminacao/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="/media/icones_social/instagram.svg"
                        alt="Instagram"
                        className="w-6 h-6 hover:scale-110 transition-transform duration-200"
                    />
                </a>
                <a
                    href="https://www.linkedin.com/company/saveenergyiluminacao/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="/media/icones_social/linkedin.svg"
                        alt="LinkedIn"
                        className="w-6 h-6 hover:scale-110 transition-transform duration-200"
                    />
                </a>
                <div className="flex items-center">
                    <button onClick={() => changeLanguage('pt')} className={`font-bold cursor-pointer ${i18n.language === 'pt' ? 'text-[#3c1053]' : 'text-neutral-500'}`}>
                        PT
                    </button>
                    <span className="text-neutral-500 font-semibold">|</span>
                    <button onClick={() => changeLanguage('en')} className={`font-bold cursor-pointer ${i18n.language === 'en' ? 'text-[#3c1053]' : 'text-neutral-500'}`}>
                        EN
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NavBar;